import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import styles from './styles.module.scss';

export type TimeExtensionModalProps = {
    isOpen: boolean;
    timeLeft: number;
    onClose: () => void;
    onConfirm: () => void;
};

export default function TimeExtensionModal({ isOpen, timeLeft, onClose, onConfirm }: TimeExtensionModalProps) {
    const { t } = useTranslation();

    const modalContent = (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))]" zIndex={70} modalIdInit="time-extension-modal" closeRegionOrder={5} closeTabIndex={5}>
            <>
                <div
                    className={`flex items-center justify-center self-stretch p-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] ${styles.popup__confirmationText}`}
                >
                    <span data-modal-region tabIndex={1} data-interactive aria-label={t('countdown.timeExtensionConfirm')} className="focus-border">
                        {t('countdown.timeExtensionConfirm')}
                    </span>
                </div>
                <p className="focus-border flex items-start justify-center px-[calc(56*var(--vh-unit))] py-[calc(24*var(--vh-unit))] pb-[calc(40*var(--vh-unit))]">
                    <span
                        aria-label={t('countdown.timeRemaining', { timeLeft })}
                        data-interactive
                        className={styles.popup__descriptionText + ' focus-border'}
                        style={{ width: 'auto', maxWidth: 'none' }}
                        tabIndex={2}
                        data-modal-region
                        data-modal-region-order={2}
                    >
                        {t('countdown.timeRemainingBefore', { timeLeft })}{' '}
                        <span className={styles.popup__timeLeft}>
                            {timeLeft} {t('countdown.secondsText')}
                        </span>{' '}
                        {t('countdown.timeRemainingAfter')}
                        <br /> <span style={{ whiteSpace: 'nowrap' }}>{t('countdown.timeRemainingQuestion')}</span>
                    </span>
                </p>
                <div className="flex items-start justify-center gap-[calc(23*var(--vh-unit))] px-[calc(56*var(--vh-unit))] py-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton role="button" variant="secondary" onClick={onConfirm} data-interactive aria-label={t('countdown.text.continue')} tabIndex={3} data-modal-region data-modal-region-order={3}>
                        {t('countdown.text.continue')}
                    </ModalButton>
                    <ModalButton role="button" variant="primary" onClick={onClose} data-interactive aria-label={t('countdown.text.goToStart')} tabIndex={4} data-modal-region data-modal-region-order={4}>
                        {t('countdown.text.goToStart')}
                    </ModalButton>
                </div>
            </>
        </Modal>
    );

    const portalRoot = document.getElementById('time-extension-modal-root');

    // Fallback to document.body if portal root doesn't exist yet
    return createPortal(modalContent, portalRoot || document.body);
}
